export default "__VITE_ASSET__Cxw$BblY__"